import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeContent";

export default function Navbar() {
  const [active, setActive] = useState(navItems[0].id);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const sections = navItems
      .map((item) => document.getElementById(item.id))
      .filter((el): el is HTMLElement => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">韩剧TV</span>
        </a>

        <nav className="nav-scroll hidden items-center gap-1 overflow-x-auto lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={
                active === item.id
                  ? "whitespace-nowrap rounded-md bg-primary-100 px-3 py-2 font-label text-sm font-medium text-primary-800"
                  : "whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
              }
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#updates"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            查看最新地址
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className={
                  active === item.id
                    ? "rounded-md bg-primary-100 px-3 py-2 font-label text-sm font-medium text-primary-800"
                    : "rounded-md px-3 py-2 font-label text-sm text-foreground-700"
                }
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}